import firebaseConfig from "../layouts/prod.firebase.config.js";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  apiDomain: "https://api.login.pgcadd.com/",
  firebaseCDN: firebaseConfig,
  NODE_ENV: "Production",
};
